// extracted by mini-css-extract-plugin
export var dividerContainer = "_9r-0";
export var line = "_9r-1";